// File: frontend/src/components/common/PinnedTopicWrap.tsx

import React from "react";
import { useTranslation } from "react-i18next";
import { RiPushpin2Fill } from "react-icons/ri";
import "./PinnedTopicWrap.css";

interface PinnedTopicWrapProps {
  // False = render the child untouched (no extra DOM around normal rows)
  pinned: boolean;
  children: React.ReactNode;
}

/**
 * Wraps the admin-pinned topic row in every left-pane list with a pin badge.
 * Non-pinned rows are returned as-is so the lists keep their exact DOM.
 */
export const PinnedTopicWrap: React.FC<PinnedTopicWrapProps> = ({ pinned, children }) => {
  const { t } = useTranslation();

  if (!pinned) return <>{children}</>;

  return (
    <div className="pinned-topic-wrap" title={t("pinned_topic_tooltip", "Yönetici tarafından sabitlendi")}>
      <RiPushpin2Fill className="pinned-topic-wrap__icon" size={12} aria-hidden="true" />
      {children}
    </div>
  );
};

export default PinnedTopicWrap;